
export default{
    authUser:state => state.authUser,
    token:state => state.token,
    userProfile:state => state.userProfile,
    meuser:state => state.meuser,
    lang:state => state.lang,
    currentRole:state => state.currentRole,
    
}